/** Reusable bits shared across the Properties page family. */

export function Stat({ label, value }) {
  return (
    <div>
      <div className="eyebrow text-[0.6rem]">{label}</div>
      <div className="text-sm mt-1">{value}</div>
    </div>
  );
}

export function Field({ label, children, required }) {
  return (
    <label className="block">
      <span className="eyebrow block mb-1.5">
        {label}
        {required && " *"}
      </span>
      {children}
    </label>
  );
}

export function Drawer({ onClose, title, children, testId = "property-drawer", maxWidth = "max-w-xl" }) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end" data-testid={testId}>
      <div className="absolute inset-0 bg-background/70" onClick={onClose} />
      <div className={`relative w-full ${maxWidth} bg-card border-l hairline overflow-y-auto`}>
        <div className="flex items-center justify-between p-6 border-b hairline sticky top-0 bg-card z-10">
          <div className="font-serif text-2xl">{title}</div>
          <button onClick={onClose} className="btn-ghost p-2" data-testid="drawer-close">
            <span aria-hidden>×</span>
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

/** Default form payload for a new property. */
export const BLANK_PROPERTY = {
  name: "",
  type: "flat",
  location: "",
  price: 7500000,
  area_sqft: 1200,
  down_payment: 2000000,
  loan_rate: 8.5,
  loan_tenure_years: 20,
  maintenance_monthly: 4000,
  property_tax_yearly: 12000,
  expected_appreciation: 6,
  rental_yield: 3,
  notes: "",
  score_location: 7,
  score_amenities: 7,
  score_safety: 8,
  score_commute: 6,
  score_resale: 7,
  status: "evaluating",
  purchase_date: "",
  purchase_price: "",
  current_value: "",
  current_loan_balance: "",
  monthly_rent_income: 0,
  rented: false,
  sold_date: "",
  sold_price: "",
};
